export default "__VITE_ASSET__oMXs7qc2__"